import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

const useStyles = ({ clamp }) =>
  makeStyles(() => ({
    lineClampStyle: {
      textAlign: 'inherit',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': clamp,
      '-webkit-box-orient': 'vertical',
    },
  }))

const LineClamp = (props) => {
  const { clamp = 2, children, ...other } = props
  const { lineClampStyle } = useStyles({ clamp })()
  return (
    <span className={lineClampStyle} title={children} {...other}>
      {children}
    </span>
  )
}

LineClamp.propTypes = {
  clamp: PropTypes.number,
  children: PropTypes.node.isRequired,
}

export default LineClamp
